import { render, staticRenderFns } from "./ActiveCountryTeasers.vue?vue&type=template&id=b94c681c&"
import script from "./ActiveCountryTeasers.vue?vue&type=script&lang=js&"
export * from "./ActiveCountryTeasers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports